import React from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../stake/Stake.css";
import { Link } from "react-router-dom";
// import EtmWrap from '../../assets/ethWrap.png'
import Footer from "../footer/Footer";
const UnStake = () => {
  return (
    <>
      <div style={{overflow:'hidden'}}>
        <div className="stackBackGroud">
          <div className="container">
            <div className="col-md-12">
              <div className="col-xl-5 col-md-6 stackBtnSwapDiv">
                <Link to="/stake">
                  <button className="btn unwrapBtnSwap2"  style={{borderRadius:'0', borderTopLeftRadius:'7px', borderBottomLeftRadius:'7px'}}>Stake</button>
                </Link>
                <Link to="">
                  <button className="btn unwrapBtnSwap1">Unstake</button>
                </Link>
              </div>
              <div className="col-xl-5 col-md-6 m-auto">
                <div className="row">
                  <div className="col-md-12 stackOuter">
                    <div className="aknsakn">
                      <div className="stackHeadingDiv">
                        <p className="stackHeading">Unstake</p>
                      </div>
                      <div className="col-md-12 stackIner">
                        <div className="col-md-12 shdbhsdshbs">
                          <div className="col-md-6">
                            <input
                              className="stackPara1"
                              type="number"
                              placeholder="0.00"
                            disabled/>
                          </div>
                        
                          <div className="col-md-6 wrapMd" style={{top:'25px'}}>
                            <div>
                              <p className="stackPara3" style={{position:'absolute'}} id='positionPara'>
                                {" "}
                                <span className="stackSpan2">Bal: </span>
                             <span style={{fontWeight:'500'}}>0.00 FTMA</span> 
                                <span className="stackSpan3"> MAX</span>{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="wrapBtnDvi">
                        <div className="stackCompounding">
                          <div>
                            <p>Pending Rewards:</p>
                          </div>
                          <div>
                            <p>0.00</p>
                          </div>
                        </div>
                        <button className="btn btn-success wrapBtn">
                          Unstake
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="stackTwobutton">
              <button className="btn stackBtnSwap3">Harvest Rewards</button>
              <div className="stackBtnSwap4div">
                <button className="btn stackBtnSwap4">Compound</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UnStake;
